import React from 'react';

import { Box, Button, Typography } from '@material-ui/core';

import { ImageUploader } from '@vyce/core/src/components/ImageUploader';
import { Image } from '@vyce/core/src/types';

import { COPY } from '../config';
import { PhotoThumbnails } from './PhotoThumbnails';

interface Props {
  isCSCS: boolean;
  photos: Image[];
  photosLimitReached: boolean;
  onAddPhoto: (image: Image) => void;
  onRemovePhoto: (index: number) => void;
  onReadPhotos: () => void;
}

export const CapturePhase = ({
  isCSCS,
  photos,
  photosLimitReached,
  onAddPhoto,
  onRemovePhoto,
  onReadPhotos,
}: Props) => {
  const isBack = isCSCS && photos.length === 1;

  const title = isCSCS
    ? isBack
      ? COPY.capture.backTitle
      : COPY.capture.frontTitle
    : COPY.qualificationIntro.title;
  const step = isCSCS ? (isBack ? COPY.capture.cscsStepBack : COPY.capture.cscsStepFront) : '';
  const hint = isCSCS
    ? isBack
      ? COPY.capture.backHint
      : COPY.capture.frontHint
    : COPY.capture.qualificationHint;

  // CSCS uploader is keyed by side so the dropzone resets between front and back.
  const uploaderKey = isCSCS ? `cscs-${photos.length}` : 'qualification';

  return (
    <Box display="flex" flexDirection="column" gridGap={16}>
      <Box>
        {!!step && (
          <Typography variant="caption" color="textSecondary">
            {step}
          </Typography>
        )}
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2" color="textSecondary">
          {hint}
        </Typography>
      </Box>

      <PhotoThumbnails photos={photos} onRemove={onRemovePhoto} />

      {!photosLimitReached && (
        <ImageUploader
          key={uploaderKey}
          type="img"
          height={180}
          uploaderWithoutPreview
          extraText={COPY.capture.dropExtraText}
          uploadText={photos.length ? COPY.capture.uploadAnother : undefined}
          onImageUpload={onAddPhoto}
        />
      )}

      {!isCSCS && (
        <Button
          variant="contained"
          color="primary"
          size="large"
          disabled={!photos.length}
          onClick={onReadPhotos}
        >
          {COPY.capture.readContinue}
        </Button>
      )}
    </Box>
  );
};
